import PropTypes from 'prop-types'
import React from 'react'
import InformationBlockCitizenField from '../question_fields/InformationBlockCitizenField'

const Citizen = ({ question }) => {
  return <InformationBlockCitizenField payload={question.payload} position={question.position} />
}

const InformationBlockQuestion = {
  Citizen,
  subtype: 'Bloque informativo',
  name: 'InformationBlockQuestion'
}

export default InformationBlockQuestion

Citizen.propTypes = {
  question: PropTypes.exact({
    payload: PropTypes.object,
    position: PropTypes.number
  }).isRequired
}
